import { Link } from "react-router-dom";

interface Post {
  slug: string;
  title: string;
  date: string;
}

interface HomeProps {
  posts: Post[];
}

export function Home({ posts }: HomeProps) {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-8" style={{ color: 'var(--gold)' }}>Writing</h1>
      <ul className="space-y-4">
        {posts.map((post) => (
          <li key={post.slug}>
            <Link
              to={`/posts/${post.slug}`}
              className="block"
              style={{ color: 'var(--text)' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--rose)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--text)'}
            >
              <span className="text-lg">{post.title}</span>
              <span className="ml-3 text-sm" style={{ color: 'var(--muted)' }}>
                {new Date(post.date).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}